import CustomTable from "../../../../components/CustomTable";
import { useEthersSigner } from "../../../../hooks/useEthersSigner";
import { schedule } from "../../vestingContractFunctions";
import "./style.css";

function VestingTable() {
  const signer = useEthersSigner();

  return (
    <div className='shared-space'>
      <h2 className='table-label mt-0'>Vesting Schedule</h2>
      <CustomTable cb={() => signer ? schedule(signer): []} currentPage={1} no={10} />
    </div>
  );
}

export default VestingTable;
